import Vue from 'vue'
import router from './router'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons' // icon
import { formatDate } from '@/utils/common'
import heatmapjsVue from 'heatmapjs-vue'
import './assets/icon/iconfont.css'
/*import './permission'*/

import "echarts-wordcloud/dist/echarts-wordcloud";
const bus = new Vue()
import VueClipboard from 'vue-clipboard2'
import { initTranslate } from './utils/translate'


VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// 把bus挂载到了Vue的原型上, 保证所有的组件都能通过 this.$bus访问到事件总线
Vue.prototype.$bus = bus
Vue.prototype.$dateMormal = formatDate
Vue.prototype.$url = process.env.WEB_URL
Vue.config.productionTip = false

initTranslate()

Vue.use(ElementUI)
Vue.use(heatmapjsVue)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js